<template>
  <div>
    <div
      class="row mb-3"
      :class="isScheduleAdded ? 'white-wrapper' : ''"
      v-if="isScheduleAdded"
    >
      <div class="col-lg-2">
        <div v-if="isScheduleAdded">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="movieSelected.ss_start_date"
                  name="showstartdate"
                  id="showstartdate"
                  v-validate="'required'"
                ></Datepicker>
                <!-- :disabledDates="{
                        to: new Date(Date.now() - 8640000)
                }"-->
                <label
                  :class="
                    typeof movieSelected.ss_start_date === 'object'
                      ? 'active'
                      : ''
                  "
                  style="background: #e9ecef"
                  >Start Date</label
                >
              </div>
            </div>
            <!-- <Tooltip :title="$t('tooltip')" />-->
          </div>
          <p
            v-if="submitted && errors.has('showstartdate')"
            class="error_message"
          >
            {{ errors.first("showstartdate") }}
          </p>
        </div>
      </div>
      <div class="col-lg-2">
        <div v-if="isScheduleAdded">
          <div>
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="movieSelected.ss_end_date"
                  name="showenddate"
                  id="showenddate"
                  v-validate="'required'"
                ></Datepicker>
                <!-- :disabledDates="{ to: new Date(Date.now() - 8640000)}" -->
                <label
                  :class="
                    typeof movieSelected.ss_start_date === 'object'
                      ? 'active'
                      : ''
                  "
                  style="background: #e9ecef"
                  >End Date</label
                >
              </div>
            </div>
            <!-- <Tooltip :title="$t('tooltip')" />-->
          </div>
          <p
            v-if="submitted && errors.has('showenddate')"
            class="error_message"
          >
            {{ errors.first("showenddate") }}
          </p>
        </div>
      </div>
      <div class="col-lg-3">
        <button
          v-on:click="onSubmitMultiSchedule('INSERT', 16)"
          class="btn-blue w-100"
        >
          Save Schedule
        </button>
      </div>
      <div class="col-lg-3">
        <button
          v-on:click="onSubmitMultiSchedule('INSERT', 19)"
          class="ml-2 btn-blue w-100"
        >
          Create Planned Schedule
        </button>
      </div>
      <div class="col-lg-2">
        <button
          v-if="isScheduleAdded"
          v-on:click="isScheduleAdded = false"
          class="ml-2 btn-blue w-100"
        >
          Edit Schedule
        </button>
      </div>
      <div class="col-lg-12 mt-3" v-if="alreadyExistArray.length > 0">
        <ul class="list">
          <li
            class="font-bold"
            v-for="(item, index) in alreadyExistArray"
            :key="index"
            :style="'color:red'"
          >
            {{ item.msg }}
          </li>
        </ul>
      </div>
    </div>

    <div class="pt-3 white-wrapper" v-if="isScheduleAdded == false">
      <!-- <button
        class="btn-modal-close"
        style="top: 15px; right: 15px; position: absolute; z-index: 99"
        @click="closeAddScheduleModal()"
      >
        &times;
      </button> -->
      <div class="row mx-0">
        <div class="col-md-3 mb-4">
          <label>{{ $tc("cinema", 2) }}</label>
          <div>
            <b-dropdown
              :disabled="isRoleID || isScheduleAdded"
              :text="selected.cinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  :placeholder="$tc('searchCinema')"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema($event.target.value)"
                  v-on:keydown="onSearchCinema($event.target.value)"
                  v-model="searchCinema"
                />
              </div>
              <b-dropdown-item
                v-for="(Cinema, CinemaIndex) in CinemasList"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
            <p
              v-if="submitted && selected.cinema == $tc('searchCinema')"
              class="error_msg"
            >
              {{ msgcinema }}
            </p>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class>
            <label>{{ $tc("startdate", 1) }}</label>
          </div>
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="
                    movieSelected.ss_start_date && isScheduleAdded === false
                  "
                  v-on:click="clear_ss_start_date()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  :disabled="isScheduleAdded"
                  ref="programaticOpen"
                  v-model="movieSelected.ss_start_date"
                  name="showstartdate"
                  id="showstartdate"
                  v-validate="'required'"
                  :disabled-dates="disabledDates"
                ></Datepicker>
                <!-- :disabledDates="{
                        to: new Date(Date.now() - 8640000)
                  }"-->
                <label
                  :class="
                    typeof movieSelected.ss_start_date === 'object'
                      ? 'active'
                      : ''
                  "
                  >{{ $tc("show") }} {{ $tc("startdate") }}
                </label>
              </div>
            </div>
            <!-- <Tooltip :title="$t('tooltip')" />-->
          </div>
          <p
            v-if="submitted && errors.has('showstartdate')"
            class="error_message"
          >
            {{ errors.first("showstartdate") }}
          </p>
        </div>

        <div class="col-md-3 mb-4">
          <div class>
            <label>{{ $tc("enddate", 1) }}</label>
          </div>
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="movieSelected.ss_end_date && isScheduleAdded === false"
                  v-on:click="clear_ss_end_date()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  :disabled="isScheduleAdded"
                  ref="programaticOpen"
                  v-model="movieSelected.ss_end_date"
                  name="showenddate"
                  id="showenddate"
                  v-validate="'required'"
                  :disabledDates="{ to: movieSelected.ss_start_date }"
                ></Datepicker>
                <label
                  :class="
                    typeof movieSelected.ss_end_date === 'object'
                      ? 'active'
                      : ''
                  "
                  >{{ $tc("show") }} {{ $tc("enddate") }}
                </label>
              </div>
            </div>
            <!-- <Tooltip :title="$t('tooltip')" />-->
          </div>
          <p
            v-if="submitted && errors.has('showenddate')"
            class="error_message"
          >
            {{ errors.first("showenddate") }}
          </p>
        </div>
        <div class="col-12 col-md-3 col-lg-3 mb-4 mb-lg-0">
          <div class>
            <label>{{ $tc("category") }} </label>
          </div>
          <div class>
            <div class="dropdown-curve-container">
              <multiselect
                :options="CategoryList"
                :searchable="true"
                v-model="CategoryName"
                label="category_name"
                track-by="category_id"
                placeholder="Select Category"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
            <p
              v-if="submitted && CategoryName.length == 0"
              class="error_message"
            >
              {{ msgcategory }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="p-1  justify-content-center align-items-center"
        v-for="(screenObj, screenMainIndex) in MultiScheduleArray"
        :key="screenMainIndex"
        :class="screenMainIndex > 0 ? 'mt-3' : ''"
      >
        <div class="row">
          <div class="col-10">
            <div class="row">
              <div class="col-md-6 col-lg-4 mb-4">
                <div class>
                  <label>{{ $t("screens") }}</label>
                </div>
                <div class>
                  <b-dropdown
                    :text="screenObj.screen_name"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search Screen Name"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchScreen($event.target.value)"
                        v-on:keydown="onSearchScreen($event.target.value)"
                        v-model="searchScreen"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(Screen, ScreenIndex) in ScreenList"
                      @click="
                        onSelectScreen(
                          $event,
                          Screen,
                          ScreenIndex,
                          screenMainIndex
                        )
                      "
                      :key="ScreenIndex"
                      ><span
                        :style="Screen.totalSeatLayout == 0 ? 'color:red' : ''"
                        >{{ Screen.screen_name }}
                        {{
                          Screen.totalSeatLayout == 0
                            ? " (No Seat Layout) "
                            : ""
                        }}</span
                      ></b-dropdown-item
                    >
                    <!-- <span :style="screen.totalSeatLayout > 0 ? 'color:red' : ''"
                      >{{ screen.screen_name }}
                    </span> -->
                  </b-dropdown>
                  <p
                    v-if="submitted && screenObj.screen_name == 'Select Screen'"
                    class="error_message"
                  >
                    {{ msgscreen }}
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class>
                  <label
                    >{{ $t("minSeats") }}
                    {{
                      screenObj["selectedScreen"]
                        ? `(Total Seats: ${screenObj["selectedScreen"].screen_no_of_seats})`
                        : ""
                    }}
                  </label>
                </div>
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      style="text-align:right;"
                      :placeholder="$t('inmins')"
                      v-model="screenObj.minSeats"
                      type="text"
                      name="MinSeats"
                      id="MinSeats"
                      v-validate="'required|numeric'"
                      @blur="validateMinSeats($event, screenObj)"
                    />
                  </div>
                </div>
                <p
                  v-if="
                    submitted &&
                      errors.has('MinSeats') &&
                      screenObj.minSeats == ''
                  "
                  class="error_message"
                >
                  Please enter minimum seats
                </p>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class>
                  <label> Private Screening Charge</label>
                </div>
                <b-dropdown
                  class="w-100"
                  variant="dropdown-curve"
                  :text="screenObj.privateRateCard.rate_card_name"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      class="form-control form-control-sm"
                      placeholder="Search Rate Card"
                      v-on:keyup="
                        onSearchPrivateRateCard($event, screenMainIndex)
                      "
                      v-on:keydown="
                        onSearchPrivateRateCard($event, screenMainIndex)
                      "
                      v-model="screenObj.privateRateCard.searchRateCard"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(Ratecard, RatecardIndex) in PrivateRatecardsList"
                    :key="RatecardIndex"
                    v-on:click="
                      onChangeRateCardScreenMulti(Ratecard, screenMainIndex)
                    "
                    >{{ Ratecard.rc_g_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <p
                  v-if="
                    submitted &&
                      screenObj.privateRateCard.rate_card_name ==
                        'Select Rate Card Group'
                  "
                  class="error_message"
                >
                  {{ msgratecard }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-2" style="text-align: end">
            <!--
                  @click.prevent.stop="increaseSeatType()"
                    v-else
                  @click.prevent.stop="decreaseSeatType(screenseatIndex)" -->
            <button
              class="btn-transparent"
              @click="onAddScreenPlus"
              v-if="screenMainIndex === 0"
            >
              <img src="@/assets/img/icons/plus.svg" height="20" width="20" />
            </button>

            <button class="btn-transparent" v-else>
              <img
                src="@/assets/img/icons/minus.svg"
                height="20"
                width="20"
                @click="onRemoveScreen(screenMainIndex)"
              />
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>
              Show Type
              <p
                v-if="submitted && screenObj.selectShowType.length == 0"
                class="error_message"
              >
                {{ msgshowType }}
              </p></label
            >
          </div>
          <div
            class="col-3 mb-3 d-flex justify-content-start align-items-center"
            v-for="(item, index_s) in ShowTypeArray"
            :key="index_s"
          >
            <input
              type="checkbox"
              class="ios-checkbox"
              @click="saveShowType(item, screenMainIndex)"
              v-model="item.value"
              style="height: 20px; width: 20px; margin-right: 5px"
            />
            <span class="switch-slider"> {{ item.screening_name }}</span>
          </div>

          <!-- <multiselect
                  :options="ShowTypeArray"
                  v-model="screenObj.selectShowType"
                  :searchable="true"
                  label="screening_name"
                  track-by="booking_type_id"
                  :placeholder="selectShowType"
                  :allowEmpty="false"
                  :showLabels="false"
                  :multiple="true"
                ></multiselect> -->
        </div>
        <div
          class="p-2 border rounded-10 justify-content-center align-items-center"
          v-for="(moviesObj, moviesIndex) in screenObj.moviesArray"
          :key="moviesIndex"
        >
          <div class="row">
            <div class="col-10">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0">
                  <div class>
                    <label>{{ $tc("movie", 1) }}</label>
                  </div>
                  <div class>
                    <div class="dropdown-curve-container">
                      <multiselect
                        :options="MoviesList"
                        v-model="moviesObj.selectedMovie"
                        :searchable="true"
                        label="movie_name"
                        track-by="md_id"
                        :placeholder="selected_movie"
                        @select="
                          onSelectMovie($event, moviesIndex, screenMainIndex)
                        "
                        :showLabels="false"
                        :multiple="true"
                      >
                        <template slot="option" slot-scope="props"
                          ><span
                            :class="
                              `${
                                !props.option.mrrdr_runtime ||
                                props.option.mrrdr_runtime == 0
                                  ? 'ssmv-red-color'
                                  : ''
                              }`
                            "
                            >{{ props.option.movie_name }}</span
                          >
                        </template>
                      </multiselect>
                    </div>
                    <p
                      v-if="submitted && moviesObj.selectedMovie.length == 0"
                      class="error_message"
                    >
                      {{ msgmovie }}
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-lg-2 mb-4 md-lg-0">
                  <div class>
                    <label>{{ $t("intervaltime") }} </label>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        :placeholder="$t('inmins')"
                        v-model="moviesObj.interval_time_in_mins"
                        type="text"
                        name="intervaltime"
                        id="intervaltime1"
                        v-validate="'required|numeric'"
                        style="text-align:right"
                      />
                    </div>
                  </div>
                  <p
                    v-if="
                      submitted &&
                        errors.has('intervaltime') &&
                        moviesObj.interval_time_in_mins == ''
                    "
                    class="error_message"
                  >
                    {{ errors.first("intervaltime") }}
                  </p>
                </div>

                <div class="col-12 col-md-6 col-lg-2 mb-4 md-lg-0">
                  <div class>
                    <label>{{ $t("cleaningtime") }} </label>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        :placeholder="$t('inmins')"
                        v-model="moviesObj.cleaning_time_in_mins"
                        type="text"
                        name="cleaningtime"
                        id="cleaningtime1"
                        v-validate="'required|numeric'"
                        style="text-align:right"
                      />
                    </div>
                  </div>
                  <p
                    v-if="
                      submitted &&
                        errors.has('cleaningtime') &&
                        moviesObj.cleaning_time_in_mins == ''
                    "
                    class="error_message"
                  >
                    {{ errors.first("cleaningtime") }}
                  </p>
                </div>

                <div class="col-12 col-md-6 col-lg-3 mb-4 md-lg-0">
                  <div class>
                    <label>{{ $t("advertisementtime") }} </label>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        :placeholder="$t('inmins')"
                        v-model="moviesObj.ads_time_in_mins"
                        type="text"
                        name="settingadstime"
                        id="settingadstime1"
                        v-validate="'required|numeric'"
                        style="text-align:right"
                      />
                    </div>
                  </div>
                  <p
                    v-if="
                      submitted &&
                        errors.has('settingadstime') &&
                        moviesObj.cleaning_time_in_mins == ''
                    "
                    class="error_message"
                  >
                    {{ errors.first("settingadstime") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-2" style="text-align: end">
              <button
                class="btn-transparent"
                v-if="moviesIndex === 0"
                @click="onAddMoviePlus(screenMainIndex)"
              >
                <img src="@/assets/img/icons/plus.svg" height="20" width="20" />
              </button>

              <button
                class="btn-transparent"
                v-else
                @click="onRemoveMovies(screenMainIndex, moviesIndex)"
              >
                <img
                  src="@/assets/img/icons/minus.svg"
                  height="20"
                  width="20"
                />
              </button>
            </div>
          </div>
          <div
            class="p-1 border rounded-10"
            v-for="(showTimeObj, showTimeIndex) in moviesObj.showTimeArray"
            :key="showTimeIndex"
          >
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-12 col-md-6 col-lg-3 mb-4 mb-lg-0">
                    <div class>
                      <label> Start Time Range</label>
                    </div>
                    <div class="custom-timepicker">
                      <div>
                        <vue-timepicker
                          style="text-align:right"
                          manual-input
                          v-model="showTimeObj.startTime2"
                          id="showtime"
                          name="showtime"
                          format="HH:mm"
                          class="time_picker"
                          input-width="100%"
                          auto-scroll
                          lazy
                          v-validate="'required'"
                          @change="
                            onChangeShowStartTime(
                              $event,
                              screenMainIndex,
                              moviesIndex,
                              showTimeIndex
                            )
                          "
                        ></vue-timepicker>
                        <!-- <date-picker
                          v-model="showTimeObj.start_time"
                          @change="
                            onChangeShowStartTime(
                              $event,
                              screenMainIndex,
                              moviesIndex,
                              showTimeIndex
                            )
                          "
                          lang="en"
                          type="time"
                          :disabled-time="true"
                          format="hh:mm a"
                          :minute-step="1"
                          class="time_picker"
                          placeholder="Show Time"
                          @input="onclose($event)"
                          name="showtime"
                          id="showtime"
                          v-validate="'required'"
                        ></date-picker> -->
                        <!-- v-model="selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].ss_start_show_time" -->
                      </div>
                      <p
                        v-if="
                          submitted &&
                            errors.has('showtime') &&
                            showTimeObj.start_time == ''
                        "
                        class="error_msg"
                      >
                        Please enter start time
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 mb-4 mb-lg-0">
                    <div class>
                      <label> End Time Range</label>
                    </div>
                    <div class="custom-timepicker">
                      <div>
                        <vue-timepicker
                          style="text-align:right"
                          manual-input
                          v-model="showTimeObj.endTime2"
                          id="endtime"
                          name="endtime"
                          format="HH:mm"
                          class="time_picker"
                          input-width="100%"
                          auto-scroll
                          lazy
                          v-validate="'required'"
                          @change="
                            onChangeShowEndTime(
                              $event,
                              screenMainIndex,
                              moviesIndex,
                              showTimeIndex
                            )
                          "
                        ></vue-timepicker>
                        <!-- <date-picker
                          v-model="showTimeObj.start_time"
                          @change="
                            onChangeShowStartTime(
                              $event,
                              screenMainIndex,
                              moviesIndex,
                              showTimeIndex
                            )
                          "
                          lang="en"
                          type="time"
                          :disabled-time="true"
                          format="hh:mm a"
                          :minute-step="1"
                          class="time_picker"
                          placeholder="Show Time"
                          @input="onclose($event)"
                          name="showtime"
                          id="showtime"
                          v-validate="'required'"
                        ></date-picker> -->
                        <!-- v-model="selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].ss_start_show_time" -->
                      </div>
                      <p
                        v-if="
                          submitted &&
                            errors.has('endtime') &&
                            showTimeObj.end_time == ''
                        "
                        class="error_msg"
                      >
                        {{ errors.first("endtime") }}
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-2 mb-4 mb-lg-0">
                    <div class>
                      <label>{{ $t("intervalMin") }}</label>
                    </div>
                    <div class="custom-timepicker">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align:right"
                            :placeholder="$t('intervalMin')"
                            v-model="showTimeObj.interval_time_min"
                            type="number"
                            name="cleaningtime"
                            id="cleaningtime1"
                            v-validate="'required|numeric'"
                          />
                        </div>
                      </div>
                      <!-- <div> -->
                      <!-- <vue-timepicker
                          :minute-interval="5"
                          format="mm"
                          name="intervalTIme"
                          id="intervalTIme"
                          manual-input
                          class="time_picker"
                          v-validate="'required'"
                          v-model="showTimeObj.interval_time_min"
                        >
                        </vue-timepicker> -->
                      <!-- <date-picker
                          v-model="showTimeObj.start_time"
                          @change="
                            onChangeShowStartTime(
                              $event,
                              screenMainIndex,
                              moviesIndex,
                              showTimeIndex
                            )
                          "
                          lang="en"
                          type="time"
                          :disabled-time="true"
                          format="hh:mm a"
                          :minute-step="1"
                          class="time_picker"
                          placeholder="Show Time"
                          @input="onclose($event)"
                          name="showtime"
                          id="showtime"
                          v-validate="'required'"
                        ></date-picker> -->
                      <!-- v-model="selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].ss_start_show_time" -->
                      <!-- </div> -->
                      <p
                        v-if="
                          submitted &&
                            errors.has('intervalTIme') &&
                            showTimeObj.interval_time_min == ''
                        "
                        class="error_msg"
                      >
                        Please Enter Interval Time
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2" style="text-align: end" v-if="false">
                <!-- v-if="screenseatIndex === 0"
                  @click.prevent.stop="increaseSeatType()"
                    v-else
                  @click.prevent.stop="decreaseSeatType(screenseatIndex)" -->
                <button
                  class="btn-transparent"
                  v-if="showTimeIndex === 0"
                  @click="onAddShowTimePlus(screenMainIndex, moviesIndex)"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="20"
                    width="20"
                  />
                </button>

                <button
                  class="btn-transparent"
                  v-else
                  @click="
                    onRemoveShowTime(
                      screenMainIndex,
                      moviesIndex,
                      showTimeIndex
                    )
                  "
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="20"
                    width="20"
                  />
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div
                class="col-12"
                v-if="getIntervals(screenMainIndex, moviesIndex, showTimeIndex)"
              >
                <b-badge
                  pill
                  style="
                    margin-left: 2px;
                    margin-bottom: 2px;
                    color: #fff;
                    background-color: #007bff;
                    padding: 7px;
                  "
                  variant="primary"
                  v-for="(item_badge, index_bad) in getIntervals(
                    screenMainIndex,
                    moviesIndex,
                    showTimeIndex
                  )"
                  :key="index_bad"
                  >{{ item_badge }}
                </b-badge>
              </div>
            </div>
            <div class="row">
              <div
                class="col-12 col-md-6 col-lg-3 mb-lg-0 mb-5"
                :key="SeatTypesIndex"
                v-for="(SeatTypes,
                SeatTypesIndex) in showTimeObj.scheduling_price"
              >
                <label>{{ SeatTypes.sst_seat_type }}</label>

                <b-dropdown
                  class="w-100"
                  variant="dropdown-curve"
                  :text="SeatTypes.rate_card_name"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      class="form-control form-control-sm"
                      placeholder="Search Rate Card"
                      v-on:keyup="
                        onSearchRateCardMulti(
                          $event,
                          screenMainIndex,
                          moviesIndex,
                          showTimeIndex,
                          SeatTypesIndex
                        )
                      "
                      v-on:keydown="
                        onSearchRateCardMulti(
                          $event,
                          screenMainIndex,
                          moviesIndex,
                          showTimeIndex,
                          SeatTypesIndex
                        )
                      "
                      v-model="SeatTypes.searchRateCard"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(Ratecard, RatecardIndex) in RatecardsList"
                    :key="RatecardIndex"
                    v-on:click="
                      onChangeRateCardMulti(
                        Ratecard,
                        SeatTypes,
                        screenMainIndex,
                        moviesIndex,
                        showTimeIndex,
                        SeatTypesIndex
                      )
                    "
                    >{{ Ratecard.rc_g_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <p
                  v-if="
                    submitted &&
                      SeatTypes.rate_card_name == 'Select Rate Card Group'
                  "
                  class="error_message"
                >
                  {{ msgratecard }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 text-center pt-4 pb-3">
        <button
          @click.prevent.stop="onSubmitMultiSchedule('INSERT', 16)"
          class="btn-blue"
        >
          {{ $t("submit") }}
        </button>
        <button @click.prevent.stop="resetHandler()" class="btn-black">
          {{ $t("reset") }}
        </button>
        <b-button
          class="btn-outline-grey"
          variant="default"
          to="schedule-list"
          >{{ $t("cancel") }}</b-button
        >
        <!-- <button @click.prevent.stop="onUpdate()" class="btn-blue">{{ $t('save') }}</button>-->
      </div>
    </div>

    <div v-if="showScheduleCard && isScheduleAdded" class="schedule-wrapper">
      <div class="d-flex w-100">
        <div class="left-nav d-none">
          <div class="sch-header">Movies</div>
          <div class="schedule-movie-list-wrapper">
            <drag
              v-for="(movie, movieIndex) in MoviesList"
              :key="movieIndex"
              :draggable="true"
              class="movie-card"
              :transfer-data="{
                type: 'newMovie',
                movie: movie,
                movieIndex: movieIndex,
              }"
            >
              <div class="schedule-movie-card">
                <div>{{ movie.movie_title }} - {{ movie.lang_name }}</div>
                <!-- <img src="@/assets/img/temp/movie.jpg" class="img-fluid" /> -->
                <img
                  v-lazy="baseURL + movie.md_thumbnail_url"
                  class="img-fluid"
                />
                <div>{{ movie.mf_name }}</div>
              </div>
            </drag>

            <hr />
          </div>
        </div>

        <div class="right-nav d-flex" @scroll="scrolfun">
          <div class="schedule-screen-list-wrapper">
            <div
              class="schedule-screen-name"
              v-for="(screen, screenIndex) in ScreenList"
              :key="screenIndex"
            >
              <span>{{ screen.screen_name }}</span>

              <!-- <span>Screen&nbsp;{{screenIndex}}</span> -->
            </div>
          </div>

          <div class="screen-time-wrapper" @scroll="scrolfun">
            <div
              class="screen-timing-header"
              :style="'top:' + topValue + 'px;'"
            >
              <div
                class="hour-box-header"
                style="width: 90px"
                v-for="(timeHeader, timeHeaderIndex) in intervalsArray"
                :key="timeHeaderIndex"
              >
                <!-- v-if="timeHeaderIndex > 8" -->
                <strong>
                  {{ timeHeader }}
                  <!-- <span v-if="timeHeaderIndex < 12">AM</span> -->
                  <!-- <span v-else>PM</span> -->
                </strong>

                <div class="minutes-bar"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar h-100"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar border-0"></div>
              </div>
            </div>

            <div
              class="schedule-screen-row"
              v-for="(screen, screenIndex) in ScreenList"
              :key="screenIndex"
            >
              <drag
                v-for="(screenMovie,
                screenMovieIndex) in selectedMoviesInScreens[screenIndex]
                  .movies"
                :key="'index' + screenIndex + screenMovieIndex"
                class="movie-horizontal-card"
                :transfer-data="{ type: 'presentMovie', movie: screenMovie }"
                @dragstart="startDrag(screenIndex, screenMovieIndex)"
                v-bind:style="{
                  'min-width': screenMovie.length + 'px',
                  left: screenMovie.start + 'px',
                  'z-index': 10,
                }"
              >
                <!-- style="top: 15px; left: 60px;z-index:10"> -->
                <div
                  class="schedule-card bg-green"
                  style="height: 98px; cursor: pointer"
                  @click="
                    onClickEditMovie(screenMovie, screenMovieIndex, screen)
                  "
                >
                  <div class="schedule-content">
                    <div>
                      <strong>{{ screenMovie.movie_title }}</strong>
                      <small class="d-block">
                        <span>{{ screenMovie.mf_name }}</span>
                        {{ screenMovie.lang_name }}
                        <span>{{ screenMovie.sound_format_name || "-" }}</span>
                      </small>
                    </div>
                    <!-- <img src="@/assets/img/temp/movie.jpg" /> -->
                    <img
                      v-if="false"
                      v-lazy="baseURL + screenMovie.md_thumbnail_url"
                      class="img-fluid"
                    />
                  </div>
                  <div class="schedule-navigations" v-if="false">
                    <button
                      class="btn-schedule-edit"
                      v-on:click="
                        onClickEditMovie(screenMovie, screenMovieIndex, screen)
                      "
                    >
                      Edit
                    </button>

                    <button
                      class="btn-schedule-add"
                      v-on:click="
                        onOpenAddPriceModal(
                          screen,
                          screenMovie,
                          screenIndex,
                          screenMovieIndex
                        )
                      "
                    >
                      Update Price
                    </button>
                    <button
                      v-on:click="
                        onDeleteMovie(
                          screen,
                          screenMovie,
                          screenIndex,
                          screenMovieIndex
                        )
                      "
                      class="btn-schedule-delete"
                    >
                      <img
                        src="@/assets/img/icons/delete-red.svg"
                        height="15"
                        width="15"
                        alt
                      />
                    </button>
                  </div>
                </div>
              </drag>
              <div
                class="hour-box"
                style="width: 90px"
                v-for="(hourofDay, hourofDayIndex) in intervalsArray"
                :key="hourofDayIndex"
              >
                <drop
                  class="minutes-bar drop"
                  v-for="(minutes, minutesIndex) in 6"
                  :key="'index' + screenIndex + minutesIndex"
                  @drop="handleDrop"
                  @dragenter="dragEnter(screenIndex, hourofDay, minutes)"
                ></drop>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- UPDATE MOVIE MODAL -->
    <b-modal
      id="updateMovie"
      ref="updateMovie"
      title="Movie Detail"
      hide-footer
      show
    >
      <div v-if="newMovieSelected.length > 0">
        <div class="row mx-0">
          <div
            class="col-12 border-bottom py-2"
            v-for="(item, index) in Object.keys(DetailMovie)"
            :key="index"
          >
            <div class="row">
              <div class="col-4">{{ DetailMovie[item] }}:</div>
              <div class="col-8">
                <strong>{{
                  item != "lengthMinutes"
                    ? newMovieSelected[0][item]
                    : convertToHrs(newMovieSelected[0][item])
                }}</strong>
              </div>
            </div>
          </div>

          <div
            class="col-12 border-bottom py-2"
            v-for="(rateCard, index) in newMovieSelected[0].scheduling_price"
            :key="index"
          >
            <div class="row">
              <div class="col-4">{{ rateCard.sst_seat_type }}:</div>
              <div class="col-8">
                <strong>
                  {{ rateCard.rate_card_name }}
                </strong>
              </div>
            </div>
          </div>

          <!-- <div class="col-12 pt-3 text-center">
            <button v-on:click="onUpdate('RemoveOldMovie')" class="btn-blue">
              Update
            </button>
          </div> -->
        </div>
      </div>
    </b-modal>

    <!-- SAVE MOVIE MODAL -->
    <b-modal
      id="saveMovie"
      ref="ratecardmodal"
      title="Update Price"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{ movieSelected.movie_title }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Showtime:</div>
              <div class="col-8">
                <strong>{{ movieSelected.start_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Runtime:</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time:</div>
              <div class="col-8">
                <strong>{{ movieSelected.end_time }}</strong>
              </div>
            </div>
          </div>

          <div
            v-for="(SeatTypes, SeatTypesIndex) in selectedScreenSeatTypes"
            :key="SeatTypesIndex"
            class="col-12 border-bottom py-2"
          >
            <div class="row">
              <div class="col-4 align-self-center">
                {{ SeatTypes.sst_seat_type }}
              </div>
              <div class="col-8">
                <b-dropdown
                  class="w-100"
                  variant="dropdown-curve"
                  :text="
                    movieSelected.scheduleShowPrice[SeatTypesIndex]
                      .rate_card_name
                  "
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Rate Card"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchRateCard($event, SeatTypesIndex)"
                      v-on:keydown="onSearchRateCard($event, SeatTypesIndex)"
                      v-model="
                        movieSelected.scheduleShowPrice[SeatTypesIndex]
                          .searchRateCard
                      "
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(Ratecard, RatecardIndex) in RatecardsList"
                    :key="RatecardIndex"
                    v-on:click="
                      onChangeRateCard(Ratecard, SeatTypes, SeatTypesIndex)
                    "
                    >{{ Ratecard.rc_g_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <p
                  v-if="
                    submitted &&
                      movieSelected.scheduleShowPrice[SeatTypesIndex]
                        .rate_card_name == 'Select Rate Card Group'
                  "
                  class="error_message"
                >
                  {{ msgratecard }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 pt-3 text-center">
            <button v-on:click="onClickupdateRateCard()" class="btn-blue">
              Update
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import momentT from "moment-timezone";

  import scheduleService from "@/services/scheduleService";
  import MyCinemaService from "@/services/MyCinemaService";
  import CinemasService from "@/services/CinemasService";
  import MasterService from "@/services/MasterService";
  import moment from "moment";
  import { BASEURL } from "@/config/index.js";
  import Vue from "vue";
  import DatePicker from "vue2-datepicker";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";

  function getInitialData() {
    return {
      searchCinema: "",
      searchScreen: "",
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      DetailMovie: {
        movie_title: "Movie Name",
        lang_name: "Language",
        mf_name: "Format",
        sound_format_name: "Sound Format",
        lengthMinutes: "Run Time",
        start_time: "Start Time",
        end_time: "End Time",
        interval_time_in_mins: "Interval Time",
        cleaning_time_in_mins: "Cleaning Time",
        ads_time_in_mins: "Advertisement Time",
      },
      timeZone: {
        tz_name: "",
        tz_utc_offset: "",
      },
      isScheduleAdded: false, // this blocks the date selector when the schedule is added for the first time
      topValue: 0,
      isRoleID: true, // HO Manager and Super Admin, this is set to false to select any Cinema
      display_time: "",
      intervalsArray: [],
      submitted: false,
      msgcinema: "Please Select Cinema",
      msgscreen: "Please Select Screen",
      msgmovie: "Please Select Movie",
      msgcategory: "Please Select Category",
      msgratecard: "Please Select Rate Card Group",
      msgshowType: "Please Select Show Type",
      // disabledDates: {
      //   to: new Date(2019, 9, 26)
      // },
      selectedMovie: [],
      selected_movie: "Select movie",
      selectedScreen: "Select a screen",
      selectedCinema: "Selected Cinema",
      rateCard: {},
      baseURL: BASEURL,
      movieSelectedIndex: null,
      newMovieSelected: [],
      movieSelected: {
        ss_start_date: "",
        ss_end_date: "",
        lang_name: "",
        md_id: 12,
        md_thumbnail_url: "/uploads/movies/1566220586425-dummy.jpg",
        mf_name: "",
        movie_id: 0,
        movie_is_active: "Y",
        movie_title: "",
        mrrdr_runtime: 0,
        selected_time_copy: "",
        sound_format_name: "",
        interval_time_in_mins: "",
        cleaning_time_in_mins: "",
        ads_time_in_mins: "",
      },
      selectedMovieIndex: null,
      selectedScreenIndex: null,
      //
      lists: {
        movies: [],
        cinemas: {
          list: [],
          selectedCinema: {
            cine_name: "select cinema",
          },
        },
        screens: [],
      },
      selectedNewDate: "",
      initialSelectedScreen: "Screen 2",
      silderOne: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 7,
      },
      silderTwo: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 5,
      },
      dropLocation: {
        screen: "",
        hour: "",
        minute: "",
      },
      draggedObject: {
        screen: "",
        length: "",
        oldStart: "",
        newStart: "",
        movie: "",
      },
      selectedMoviesInScreens: [],

      // Saif
      PrivateRatecardsList: [],
      PrivateRatecardsListCopy: [],
      showScheduleCard: false,
      selectedScreenSeatTypes: [],
      selectedRateCardObject: {},

      CinemasList: [],
      CinemasListCopy: [],
      MoviesList: [],
      ScreenList: [],
      ScreenListCopy: [],
      RatecardsList: [],
      RatecardsListCopy: [],
      CinemasSettings: {
        cine_setting_id: null,
        cine_id: null,
        cine_operation_start_time: null,
        cine_operation_end_time: null,
        cine_cleaning_time_in_mins: null,
        cine_setting_ads_time_in_mins: null,
        cine_interval_time_in_mins: null,
        cine_seat_release_time_in_mins: null,
        cine_cutoff_time_in_mins: null,
        cine_setting_is_active: "Y",
        cine_time_zone: "",
      },
      selected: {
        cinema: "Select Cinema",
        screen_name: "Select Screen",
        cinemaObject: {},
      },
      scheduleObject: {
        cinema_id: null,
        sch_start_date: null,
        sch_end_date: null,
        sch_is_active: "Y",
      },
      ShowTypeArray: [
        {
          booking_type_id: "1",
          screening_name: "Confirmed Screening",
          value: false,
        },
        {
          booking_type_id: "2",
          screening_name: "CrowdSource Screening",
          value: false,
        },
        {
          booking_type_id: "3",
          screening_name: "Private Screening",
          value: false,
        },
      ],
      selectShowType: "Select Show Type",

      MultiScheduleArray: [
        {
          screen_id: "",
          minSeats: "",
          screen_name: "Select Screen",
          selectShowType: [],
          selectedScreen: "",
          privateRateCard: {
            rate_card_id: "",
            rate_card_group_id: "",
            rate_card_name: "Select Rate Card Group",
            searchRateCard: "",
          },
          moviesArray: [
            {
              movie_details_id: "",
              selectedMovie: [],
              interval_time_in_mins: "",
              cleaning_time_in_mins: "",
              ads_time_in_mins: "",
              showTimeArray: [
                {
                  start_time: "",
                  scheduling_price: [],
                  startTime2: "",
                  end_time: "",
                  endTime2: "",
                  interval_time_min: "",
                },
              ],
              lengthMinutes: "",
            },
          ],
        },
      ],
      alreadyExistArray: [],
      CategoryList: [],
      CategoryName: "",
    };
  }

  export default {
    components: { DatePicker, VueTimepicker },

    data() {
      return getInitialData();
    },
    computed: {
      isMovieSelected() {
        return (
          this.selectedMoviesInScreens.filter((singleScreen) => {
            return singleScreen.movies.length > 0;
          }).length > 0
        );
      },
    },
    beforeMount: function() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      // this.getAllActiveScreens();
      this.getGoGoCategory();
      this.getAllActiveCinemas(obj);
    },
    mounted() {
      // this.$refs.test.show();
    },
    methods: {
      saveShowType(item, screenIndex) {
        let findIndeNew = this.MultiScheduleArray[screenIndex][
          "selectShowType"
        ].findIndex((x) => {
          return x.booking_type_id == item.booking_type_id;
        });
        if (findIndeNew >= 0) {
          this.MultiScheduleArray[screenIndex]["selectShowType"].splice(
            findIndeNew,
            1
          );
        } else {
          this.MultiScheduleArray[screenIndex]["selectShowType"].push(item);
        }
        console.log(
          this.MultiScheduleArray[screenIndex]["selectShowType"],
          "fdfsdfsd"
        );
      },
      onChangeShowEndTime(event, screenIndex, movieIndex, showTimeIndex) {
        event = new Date(
          moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
        );

        this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
          "showTimeArray"
        ][showTimeIndex]["end_time"] = event;
        console.log(
          this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
            "showTimeArray"
          ]
        );
      },
      resetHandler() {
        this.CategoryName = "";
        this.getGoGoCategory();
        Object.assign(this.$data, getInitialData());
        $("#intervalTIme").val("");
        $("#showtime").val("");
        $("#endtime").val("");
        let obj = this.secureStore.get("USINFO").cinema_id;
        let roleid = this.secureStore.get("USINFO").role_id;
        if (true) {
          this.isRoleID = false;
        }
        this.ShowTypeArray.map((y) => {
          y.value = false;
        });
        // this.getAllActiveScreens();
        // this.getAllMovies();
        this.getAllActiveCinemas(obj);
      },
      getDates(startDate, stopDate) {
        console.log("startDate :", startDate);
        console.log("stopDate :", stopDate);
        console.log("this :", self);
        console.log("this.timeZone :", self.timeZone);
        var dateArray = [];
        var currentDate = moment(startDate);
        var stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        console.log("dateArray :", dateArray);
        return dateArray;
      },
      getStartTimeVal(moviesObj) {
        moviesObj.length = (moviesObj.lengthMinutes * 30) / 10;

        let start = 0;
        let hours = 0;
        let minutes = 0;
        let totalMinutes = 0;

        // moviesObj.start_time = this.onChangeTimePicker(
        //   moviesObj.selected_time
        // );
        // moviesObj.selected_time_copy = moviesObj.selected_time;

        let cinema_start = this.getScreenPositionCalc(
          this.CinemasSettings.cine_operation_start_time
        );

        let show_start_time = ""; //ref.getScreenPositionCalc(startTime);
        if (
          moment(
            moment()
              .tz(this.timeZone.tz_name)
              .format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          )
            .tz(this.timeZone.tz_name)
            .format("HH:mm") <=
          moment(
            moment()
              .tz(this.timeZone.tz_name)
              .format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_start_time
          )
            .tz(this.timeZone.tz_name)
            .format("HH:mm")
        ) {
          console.log("camehere11111 :");
          if (
            moment(
              moment()
                .tz(this.timeZone.tz_name)
                .format("YYYY-MM-DD") +
                " " +
                this.CinemasSettings.cine_operation_end_time
            ).isAfter(
              moment(
                moment()
                  .tz(this.timeZone.tz_name)
                  .format("YYYY-MM-DD") +
                  " " +
                  moviesObj.start_time
              )
            )
          ) {
            show_start_time =
              4320 + this.getScreenPositionCalc(moviesObj.start_time);
          } else {
            console.log("camehere222222222222 :");

            show_start_time = this.getScreenPositionCalc(moviesObj.start_time);
          }
        } else {
          console.log("camehere333333333333333333333 :");

          show_start_time = this.getScreenPositionCalc(moviesObj.start_time);
        }

        console.log("this.show_start_time :", show_start_time);

        let start_delay = this.getScreenPositionCalc("00:30");
        console.log(
          "show_start_time , cinema_start , start_delay :",
          show_start_time,
          cinema_start,
          start_delay
        );
        start = show_start_time - cinema_start + start_delay;

        return start;
      },

      getIntervals(screenIndex, movieIndex, showTimeIndex) {
        let start_time = this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ]["showTimeArray"][showTimeIndex]["start_time"];
        let end_time = this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ]["showTimeArray"][showTimeIndex]["end_time"];
        let interval_time = this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ]["showTimeArray"][showTimeIndex]["interval_time_min"];

        if (
          start_time &&
          end_time &&
          interval_time &&
          moment(end_time).isAfter(start_time)
        ) {
          var start = moment(start_time, "YYYY-MM-DD hh:mm a");
          var end = moment(end_time, "YYYY-MM-DD hh:mm a");

          if (interval_time == "00") {
            interval_time = 60;
          }

          // round starting minutes up to nearest 15 (12 --> 15, 17 --> 30)
          // note that 59 will round up to 60, and moment.js handles that correctly
          start.minutes(Math.ceil(start.minutes() / 15) * 15);

          var result = [];

          var current = moment(start);

          while (current <= end) {
            result.push(current.format("HH:mm"));
            current.add(interval_time, "minutes");
          }
          console.log(result, "fsdfsdfsdfsd");

          return result;
        } else {
          console.log("fsfsdf");
          return null;
        }
      },

      onAddScreenPlus() {
        let ScreenObj = {
          screen_id: "",
          minSeats: "",
          screen_name: "Select Screen",
          selectedScreen: "",
          selectShowType: [],
          privateRateCard: {
            rate_card_id: "",
            rate_card_group_id: "",
            rate_card_name: "Select Rate Card Group",
            searchRateCard: "",
          },
          moviesArray: [
            {
              movie_details_id: "",
              selectedMovie: [],
              interval_time_in_mins: "",
              cleaning_time_in_mins: "",
              ads_time_in_mins: "",
              showTimeArray: [
                {
                  start_time: "",
                  scheduling_price: [],
                  startTime2: "",
                  end_time: "",
                  endTime2: "",
                  interval_time_min: "",
                },
              ],
              lengthMinutes: "",
            },
          ],
        };
        this.MultiScheduleArray.push(ScreenObj);
      },
      onRemoveScreen(screenIndex) {
        this.MultiScheduleArray.splice(screenIndex, 1);
      },
      onAddMoviePlus(screenIndex) {
        let MoviesObj = {
          movie_details_id: "",
          selectedMovie: [],
          interval_time_in_mins: "",
          cleaning_time_in_mins: "",
          ads_time_in_mins: "",
          showTimeArray: [
            {
              start_time: "",
              scheduling_price: [],
              startTime2: "",
              end_time: "",
              endTime2: "",
              interval_time_min: "",
            },
          ],
          lengthMinutes: "",
        };

        if (this.MultiScheduleArray[screenIndex].selectedScreen != "") {
          if (
            this.MultiScheduleArray[screenIndex].selectedScreen
              .screen_seat_types.length > 0
          ) {
            this.MultiScheduleArray[
              screenIndex
            ].selectedScreen.screen_seat_types.map((y) => {
              let obj = {
                screen_seat_type_id: y.sst_id,
                sst_seat_type: y.sst_seat_type,
                rate_card_id: "",
                searchRateCard: "",
                rate_card_name: "Select Rate Card Group",
              };
              MoviesObj.showTimeArray[0].scheduling_price.push(obj);
            });
          }
        }
        this.MultiScheduleArray[screenIndex]["moviesArray"].push(MoviesObj);
      },
      onRemoveMovies(screenIndex, movieIndex) {
        this.MultiScheduleArray[screenIndex]["moviesArray"].splice(
          movieIndex,
          1
        );
      },
      onAddShowTimePlus(screenIndex, movieIndex) {
        let showTimeObj = {
          start_time: "",
          scheduling_price: [],
        };

        if (
          this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
            "showTimeArray"
          ][0]["scheduling_price"].length > 0
        ) {
          this.MultiScheduleArray[
            screenIndex
          ].selectedScreen.screen_seat_types.map((y) => {
            let obj = {
              screen_seat_type_id: y.sst_id,
              sst_seat_type: y.sst_seat_type,
              rate_card_id: "",
              searchRateCard: "",
              rate_card_name: "Select Rate Card Group",
            };
            showTimeObj.scheduling_price.push(obj);
          });
        }
        this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
          "showTimeArray"
        ].push(showTimeObj);
      },
      onRemoveShowTime(screenIndex, movieIndex, showTimeIndex) {
        this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
          "showTimeArray"
        ].splice(showTimeIndex, 1);
      },
      closeAddScheduleModal: function() {
        this.$refs["test"].hide();
        this.$router.push({
          path: "/cinema-manager/view-schedule",
        });
      },
      onSearchCinema(value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.CinemasList = this.CinemasListCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.CinemasList = this.CinemasListCopy;
        }
      },
      onSearchScreen(value) {
        if (this.searchScreen && this.searchScreen.length > 0) {
          this.ScreenList = this.ScreenListCopy.filter((x) => {
            if (
              x.screen_name
                .toLowerCase()
                .includes(this.searchScreen.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.ScreenList = this.ScreenListCopy;
        }
      },
      scrolfun() {
        console.log("scrolling");
        this.topValue = event.srcElement.scrollTop;
      },
      onResetAddModal: function() {
        // (this.selected.cinema = "Please Select Cinema"),
        this.selected.screen_name = "Select Screen";
        this.selectedScreen = {};
        this.selectedScreenIndex = null;
        this.movieSelected.start_time = null;
        this.$refs["test"].show();
        // this.selectedScreenSeatTypes = [];
        // this.selectedMovie = {};
        // console.log("this.selectedMovie :>> ", this.selectedMovie);
        //TODO - if cinema is already selected, make it non editable
        // if(this.isScheduleAdded == true){
        //   this.onSelectCinema(null, this.selected.cinemaObject)
        // }else{
        // this.selected.cinema = "Please Select Cinema";
        // }
        // this.selectedMovie = "Please Select Movie";
        // this.selected.screen_name = "Please Select Screen";
      },

      onclose: function(e) {},
      clear_ss_start_date: function() {
        this.movieSelected.ss_start_date = null;
      },
      clear_ss_end_date: function() {
        this.movieSelected.ss_end_date = null;
      },
      onChangeTimePicker: function(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
        // this.movieSelected.start_time = formatAMPM(this.movieSelected.start_time);
      },
      convertToHrs: function(value) {
        let hours = Math.floor(value / 60);
        let minutes = Math.floor(value % 60);
        return hours + "hrs " + minutes + " mins";
      },
      onChangeTime: function(event) {
        console.log("eventaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa  :", event);
        this.movieSelected.start_time = event.target.value;
        this.display_time = moment(event.target.value).format("h:mm A");
        this.movieSelected["selected_time"] = event.target.value;
      },
      onEditStartTime: function(event) {
        this.onChangeShowStartTime(event);
      },
      onSearchRateCardScreenMulti: function(event, screenIndex) {
        this.MultiScheduleArray[screenIndex]["privateRateCard"][
          "searchRateCard"
        ] = event.target.value;
        let searchVal = this.MultiScheduleArray[screenIndex]["privateRateCard"][
          "searchRateCard"
        ];
        if (searchVal.length > 0) {
          this.RatecardsList = this.RatecardsListCopy.filter((x) => {
            if (x.rc_g_name.toLowerCase().includes(searchVal.toLowerCase()))
              return x;
          });
        } else {
          this.RatecardsList = this.RatecardsListCopy;
        }
        this.$forceUpdate();
      },
      onSearchPrivateRateCard: function(event, screenIndex) {
        this.MultiScheduleArray[screenIndex]["privateRateCard"][
          "searchRateCard"
        ] = event.target.value;
        let searchVal = this.MultiScheduleArray[screenIndex]["privateRateCard"][
          "searchRateCard"
        ];
        if (searchVal.length > 0) {
          this.PrivateRatecardsList = this.PrivateRatecardsListCopy.filter(
            (x) => {
              if (x.rc_g_name.toLowerCase().includes(searchVal.toLowerCase()))
                return x;
            }
          );
        } else {
          this.PrivateRatecardsList = this.PrivateRatecardsListCopy;
        }
        this.$forceUpdate();
      },

      onSearchRateCardMulti: function(
        event,
        screenIndex,
        movieIndex,
        showTimeIndex,
        RatecardIndex
      ) {
        this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
          "showTimeArray"
        ][showTimeIndex]["scheduling_price"][RatecardIndex]["searchRateCard"] =
          event.target.value;
        let searchVal = this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ]["showTimeArray"][showTimeIndex]["scheduling_price"][RatecardIndex][
          "searchRateCard"
        ];
        if (searchVal.length > 0) {
          this.RatecardsList = this.RatecardsListCopy.filter((x) => {
            if (x.rc_g_name.toLowerCase().includes(searchVal.toLowerCase()))
              return x;
          });
        } else {
          this.RatecardsList = this.RatecardsListCopy;
        }
        this.$forceUpdate();
      },
      onSearchRateCard: function(event, RatecardIndex) {
        this.movieSelected.scheduleShowPrice[RatecardIndex]["searchRateCard"] =
          event.target.value;
        if (
          this.movieSelected.scheduleShowPrice[RatecardIndex]["searchRateCard"]
            .length > 0
        ) {
          this.RatecardsList = this.RatecardsListCopy.filter((x) => {
            if (
              x.rc_g_name
                .toLowerCase()
                .includes(
                  this.movieSelected.scheduleShowPrice[RatecardIndex][
                    "searchRateCard"
                  ].toLowerCase()
                )
            )
              return x;
          });
        } else {
          this.RatecardsList = this.RatecardsListCopy;
        }
        this.$forceUpdate();
      },
      byDefaultRateCard(start_time, screenIndex, movieIndex, showTimeIndex) {
        let arrayMap = this.selectedMoviesInScreens[screenIndex][
          "screen_seat_card_mapping"
        ];

        let mapping_array = [];
        arrayMap.map((z) => {
          let range = [z.start_time, z.end_time];
          let findIndexNew = this.MultiScheduleArray[screenIndex][
            "moviesArray"
          ][movieIndex]["showTimeArray"][
            showTimeIndex
          ].scheduling_price.findIndex((sch) => {
            return sch.screen_seat_type_id == z.screen_seat_type_id;
          });
          if (start_time >= range[0] && start_time <= range[1]) {
            if (findIndexNew >= 0) {
              this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
                "showTimeArray"
              ][showTimeIndex].scheduling_price[findIndexNew]["rate_card_id"] =
                z.rate_card_id;
              this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
                "showTimeArray"
              ][showTimeIndex].scheduling_price[findIndexNew][
                "rate_card_name"
              ] = z.rc_g_name;
            }
            mapping_array.push(z);
          } else {
            this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
              "showTimeArray"
            ][showTimeIndex].scheduling_price[findIndexNew]["rate_card_id"] =
              "";
            this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
              "showTimeArray"
            ][showTimeIndex].scheduling_price[findIndexNew]["rate_card_name"] =
              "Select Rate Card Group";
          }
        });
      },
      onChangeShowStartTime: function(
        event,
        screenIndex,
        movieIndex,
        showTimeIndex
      ) {
        event = new Date(
          moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
        );
        console.log("fff");

        this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
          "showTimeArray"
        ][showTimeIndex]["start_time"] = event;
        let start_time = event;
        let a = "";
        a = moment(
          moment().format("YYYY-MM-DD") + " " + moment(event).format("HH:mm")
        );
        console.log("a :", a);
        if (this.MultiScheduleArray[screenIndex].screen_id != "") {
          this.byDefaultRateCard(
            moment(event).format("HH:mm"),
            screenIndex,
            movieIndex,
            showTimeIndex
          );
        }
        return false;
        // this.getIntervals(screenIndex, movieIndex, showTimeIndex);
        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_start_time
          ).isAfter(a)
        ) {
          a = moment(
            moment()
              .add(1, "days")
              .format("YYYY-MM-DD") +
              " " +
              moment(event).format("HH:mm")
          );
        }
        console.log("a :", a);
        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          ).isBefore(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.CinemasSettings.cine_operation_start_time
            )
          )
        ) {
          if (
            moment(
              moment()
                .add(1, "days")
                .format("YYYY-MM-DD") +
                " " +
                this.CinemasSettings.cine_operation_end_time
            ).isSameOrAfter(a) &&
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.CinemasSettings.cine_operation_start_time
            ).isSameOrBefore(a)
          ) {
            console.log(
              "object :",
              this.CinemasSettings.cine_operation_end_time
            );
            console.log("came here 1 aaaaaaaaa :");
            console.log("event :", event);
            start_time = event;
            start_time = event;
            // this.
            this.$forceUpdate();
          } else {
            this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
              "showTimeArray"
            ][showTimeIndex]["start_time"] = "";
            return this.$toasted.show(
              "Cannot select showtime beyond Operation Timings "
            );
          }
        } else if (
          this.CinemasSettings.cine_operation_end_time ==
            this.CinemasSettings.cine_operation_start_time ||
          (moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          ).isSameOrAfter(a) &&
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.CinemasSettings.cine_operation_start_time
            ).isSameOrBefore(a))
        ) {
          console.log("came here 2222222 :", event);

          this.$forceUpdate();
        } else {
          this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
            "showTimeArray"
          ][showTimeIndex]["start_time"] = "";
          return this.$toasted.show(
            "Cannot select showtime beyond Operation Timings "
          );
        }
      },
      onClickEditMovie: function(screenMovie, screenMovieIndex, screen) {
        console.log(screenMovie, screenMovieIndex, screen);
        this.newMovieSelected = [];
        this.newMovieSelected.push(screenMovie);

        this.$refs["updateMovie"].show();
        this.$forceUpdate();
      },
      onSubmitMultiSchedule(action, showStatus) {
        this.submitted = true;
        let NewMultiSheduleArray = [];
        this.$validator.validate().then((valid) => {
          console.log(this.MultiScheduleArray);
          let count = 0;
          this.MultiScheduleArray.map((x) => {
            if (x.selectShowType.length == 0) {
              count++;
            }
            let obj = {
              screen_id: x.screen_id,
              screen_name: x.screen_name,
              privateRateCard: x.privateRateCard,
              selectShowType: Array.prototype.map
                .call(x.selectShowType, function(item) {
                  return item.booking_type_id;
                })
                .join(","),
              moviesArray: [],
            };
            if (x.screen_id == "") {
              count++;
              console.log("Screen");
            }
            x.moviesArray.map((y) => {
              if (y.selectedMovie.length == 0) {
                count++;
                console.log("Movie");
              }

              y.selectedMovie.map((moviesObjId) => {
                let movieObj = {
                  cleaning_time_in_mins: y.cleaning_time_in_mins,
                  interval_time_in_mins: y.interval_time_in_mins,
                  ads_time_in_mins: y.ads_time_in_mins,
                  movie_details_id: moviesObjId.md_id,
                  min_seats: x.minSeats,
                  booked_seats: 0,
                  gogo_user_id: 0,
                  ss_category_id: 0,
                };

                y.showTimeArray.map((z) => {
                  let MovieObjNew = {};

                  Object.assign(MovieObjNew, { ...movieObj, ...z });
                  if (z["start_time"] != "") {
                    MovieObjNew["start_time"] = moment(z.start_time).format(
                      "HH:mm"
                    );
                    MovieObjNew["end_time"] = moment(z.end_time).format(
                      "HH:mm"
                    );

                    MovieObjNew["lengthMinutes"] = moviesObjId.lengthMinutes;

                    MovieObjNew["start"] =
                      this.getStartTimeVal(MovieObjNew) / 2;
                    MovieObjNew["length"] = (moviesObjId.lengthMinutes * 3) / 2;
                    MovieObjNew["mf_name"] = moviesObjId.mf_name;
                    MovieObjNew["sound_format_name"] =
                      moviesObjId.sound_format_name;
                    MovieObjNew["md_thumbnail_url"] =
                      moviesObjId.md_thumbnail_url;
                    MovieObjNew["lang_name"] = moviesObjId.lang_name;
                    MovieObjNew["movie_title"] = moviesObjId.movie_title;
                    MovieObjNew["ss_show_status"] = showStatus;
                  }
                  obj.moviesArray.push(MovieObjNew);

                  let checkRate = z.scheduling_price.filter((k) => {
                    return k.rate_card_name == "Select Rate Card Group";
                  });
                  if (checkRate.length > 0) {
                    count++;
                  }
                });
              });
            });
            NewMultiSheduleArray.push(obj);
          });

          setTimeout(() => {
            if (
              valid &&
              count == 0 &&
              this.CategoryName.hasOwnProperty("category_id")
            ) {
              let payload = {
                cinema_id: this.CinemasSettings.cine_id,
                category_id: this.CategoryName.category_id,
                sch_start_date: moment(this.movieSelected.ss_start_date).format(
                  "YYYY-MM-DD"
                ),
                sch_end_date: moment(this.movieSelected.ss_end_date).format(
                  "YYYY-MM-DD"
                ),
                ACTION: action,
                timeZone: this.timeZone,
                CinemasSettings: this.CinemasSettings,
                MultipleSchedule: NewMultiSheduleArray,
              };
              let datesCheck = this.getDates(
                this.movieSelected.ss_start_date,
                this.movieSelected.ss_end_date
              );

              // console.log(payload, "fdsf");
              // return false;
              MyCinemaService.addMultipleScheduleV2(payload).then((result) => {
                const { data } = result;
                if (data.status) {
                  if (action == "VALIDATE") {
                    this.alreadyExistArray = [];
                    let countAll = 0;
                    data.Records.screen.map((x) => {
                      let ScreenIndex = this.selectedMoviesInScreens.findIndex(
                        (zin) => {
                          return zin.screen_id == x.screen_id;
                        }
                      );

                      if (ScreenIndex >= 0) {
                        this.selectedMoviesInScreens[ScreenIndex][
                          "movies"
                        ] = [];
                        let count = 0;
                        x.moviesArray.map((y) => {
                          let obj = {};
                          if (y.dateExist.length != datesCheck.length) {
                            this.selectedMoviesInScreens[ScreenIndex][
                              "movies"
                            ].push(y);

                            obj = {
                              dateCheck: y.dateExist,
                              msg:
                                "Your " +
                                y.dateExist.join(", ") +
                                " schedule is already exist on this " +
                                y.start_time +
                                "in Screen " +
                                x.screen_name,
                            };
                          } else {
                            count++;
                            obj = {
                              dateCheck: y.dateExist,
                              msg:
                                "Your all schedule is already exist on this " +
                                y.start_time +
                                " in Screen " +
                                x.screen_name,
                            };
                          }

                          if (y.dateExist.length > 0) {
                            this.alreadyExistArray.push(obj);
                          }
                        });
                        if (count == x.moviesArray.length) {
                          countAll++;
                        }
                      }
                      console.log("New Check");
                    });
                    console.log("Check", countAll);

                    if (countAll == data.Records.screen.length) {
                      this.$toasted.show(
                        "Already Exist All Show of all Screen"
                      );
                    } else {
                      this.isScheduleAdded = true;
                      this.$toasted.show("You can preview your schedule.");
                    }
                  }

                  if (action == "INSERT") {
                    this.$toasted.show(data.message);
                    this.resetHandler();
                    // this.$router.push({
                    //   path: "/cinema-manager/view-schedule",
                    // });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              });
            }
          }, 1000);
        });
      },

      getScreenPositionCalc: function(start_time) {
        let cinema_start_time = this.CinemasSettings.cine_operation_start_time;
        let cinema_ampm = cinema_start_time.split(" ")[1];
        let cinema_minutes = parseInt(cinema_start_time.split(":")[1]);
        let cinema_hours = parseInt(cinema_start_time.split(":")[0]);

        let start = 0;
        let cinema_start = 0;
        let hours = 0;
        let minutes = 0;
        let totalMinutes = 0;
        let ampm = start_time.split(" ")[1];
        minutes = parseInt(start_time.split(":")[1]);
        hours = parseInt(start_time.split(":")[0]);
        if (ampm == "PM" && hours === 12) {
          hours = hours;
        } else if (ampm == "PM") {
          hours = hours + 12;
        }
        // if(cinema_hours < hours){
        //   hours =
        // }
        if (ampm == "AM" && hours === 12) {
          totalMinutes = minutes;
          cinema_start = parseInt(totalMinutes * 30) / 10;
          return cinema_start;
        } else {
          totalMinutes = parseInt(hours * 60) + minutes;
          cinema_start = parseInt(totalMinutes * 30) / 10;
          return cinema_start;
        }

        totalMinutes = parseInt(hours * 60) + minutes;
        cinema_start = parseInt(totalMinutes * 30) / 10;
        return cinema_start;
      },

      tConvert: function(time) {
        // Check correct time format and split into components
        time = time
          .toString()
          .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return { digit: time[0], join: time.join("") }; // return adjusted time or original string
      },
      // Cinema List
      getAllActiveCinemas: function(cine_id) {
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.CinemasList = data.Records;
              this.CinemasListCopy = data.Records;
              this.CinemasList.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // this.selected.cinema = x.cine_name;
                  let cinema = {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  };
                  this.onSelectCinema(event, cinema);
                }
              });
            } else {
              // Show Error message
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveCinemas :", error);
          });
      },

      getCinemaSetting: function(cinema_id) {
        scheduleService
          .GetCinemaSetting({ cinema_id })
          .then((response) => {
            const { data } = response;
            console.log("data.timeZone :", data.timeZone);
            if (data && data.status && data.Records.length > 0) {
              this.CinemasSettings = {
                ...this.CinemasSettings,
                ...data.Records[0],
              };
              if (
                data.timeZone &&
                data.timeZone.tz_name &&
                data.timeZone.tz_name.length > 0
              ) {
                this.timeZone = {
                  ...this.timeZone,
                  ...data.timeZone,
                };
                this.getAllActiveMovies();
              } else {
                this.$toasted.show(
                  "Please Add default Timezone in Cinema Settings"
                );
                this.$refs["test"].hide();
              }
              console.log("this.cinemaSettings :", this.CinemasSettings);
              console.log("this.cinemaSettings :", this.timeZone);

              // let startString = moment(
              //   moment().format("YYYY-MM-DD") +
              //     " " +
              //     this.CinemasSettings.cine_operation_start_time
              // ).format("YYYY-MM-DD h:mm A");

              // let endString = moment(
              //   moment().format("YYYY-MM-DD") +
              //     " " +
              //     this.CinemasSettings.cine_operation_end_time
              // ).format("YYYY-MM-DD h:mm A");
              let startString = "";
              if (
                this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                  "AM" ||
                this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                  "PM"
              ) {
                startString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).format("YYYY-MM-DD h:mm A");
              } else {
                startString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).format("YYYY-MM-DD H:mm");
              }

              let endString = "";
              if (
                this.CinemasSettings.cine_operation_end_time.split(" ")[1] ==
                  "AM" ||
                this.CinemasSettings.cine_operation_end_time.split(" ")[1] ==
                  "PM"
              ) {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                ).format("YYYY-MM-DD h:mm A");
              } else if (
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).isAfter(
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      this.CinemasSettings.cine_operation_end_time
                  )
                )
              ) {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
                  .add(1, "d")
                  .format("YYYY-MM-DD H:mm");
              } else if (
                this.CinemasSettings.cine_operation_end_time.split(":")[0] < 12
              ) {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
                  .add(1, "d")
                  .format("YYYY-MM-DD H:mm");
              }
              // else if (
              //   this.CinemasSettings.cine_operation_end_time <=
              //   this.CinemasSettings.cine_operation_start_time
              // ) {
              //   endString = moment(
              //     moment().format("YYYY-MM-DD") +
              //       " " +
              //       this.CinemasSettings.cine_operation_end_time
              //   )
              //     .add(1, "d")
              //     .format("YYYY-MM-DD H:mm");
              // }
              else {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                ).format("YYYY-MM-DD H:mm");
              }
              this.intervalsArray = intervals(startString, endString);
              function intervals(startString, endString) {
                var start = moment(startString, "YYYY-MM-DD hh:mm a");
                var end = moment(endString, "YYYY-MM-DD hh:mm a");

                // round starting minutes up to nearest 15 (12 --> 15, 17 --> 30)
                // note that 59 will round up to 60, and moment.js handles that correctly
                start.minutes(Math.ceil(start.minutes() / 15) * 15);

                var result = [];

                var current = moment(start);
                end = moment(end);
                end.add(4 * 60, "minutes");
                console.log("current :", current);
                while (current <= end) {
                  result.push(current.format("HH:mm"));
                  current.add(60, "minutes");
                }

                return result;
              }
            } else {
              this.$toasted.show(
                "No Cinema Settings Found for selected cinema"
              );
              this.$refs["test"].hide();
              // Show Message Here:
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getCinemaSetting :", error);
          });
      },
      //
      getRatecardsList: function(cinema_id) {
        scheduleService
          .GetPrivateRatecardGroupByCinemaId({ cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.RatecardsList = data.Records.filter(
                (x) => x.is_private_rate_card == "N"
              );
              this.RatecardsListCopy = data.Records.filter(
                (x) => x.is_private_rate_card == "N"
              );
              this.PrivateRatecardsList = data.Records.filter(
                (x) => x.is_private_rate_card == "Y"
              );
              this.PrivateRatecardsListCopy = data.Records.filter(
                (x) => x.is_private_rate_card == "Y"
              );
            } else {
              this.RatecardsList = [];
              this.RatecardsListCopy = [];
              this.PrivateRatecardsList = [];
              this.PrivateRatecardsListCopy = [];
              // Show Message Here:
              this.$toasted.show("No Rate Cards Found for selected cinema");
              this.$refs["test"].hide();
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getCinemaSetting :", error);
          });
      },

      getAllActiveMovies: function() {
        scheduleService
          .GetMovies()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.MovieListResult.length > 0) {
              this.MoviesList = data.MovieListResult.filter(
                (movie, movieIndex) => {
                  if (movie.movie_is_active == "Y") {
                    movie.lengthMinutes =
                      movie.mrrdr_runtime +
                      this.CinemasSettings.cine_cleaning_time_in_mins +
                      this.CinemasSettings.cine_setting_ads_time_in_mins +
                      this.CinemasSettings.cine_interval_time_in_mins;
                    movie.length = (movie.lengthMinutes * 30) / 10;
                    movie.rateCard = [];
                    movie.scheduleShowPrice = [];
                    movie.md_id = movie.md_id;
                    movie.interval_time_in_mins = this.CinemasSettings.cine_interval_time_in_mins;
                    movie.cleaning_time_in_mins = this.CinemasSettings.cine_cleaning_time_in_mins;
                    movie.ads_time_in_mins = this.CinemasSettings.cine_setting_ads_time_in_mins;
                    movie.movie_name = movie.movie_name;
                    movie.movie =
                      movie.sound_format_name &&
                      String(movie.sound_format_name).length > 0
                        ? movie.movie_title +
                          " " +
                          movie.mf_name +
                          " (" +
                          movie.lang_name +
                          ")" +
                          " (" +
                          movie.sound_format_name +
                          ")"
                        : movie.movie_title +
                          " " +
                          movie.mf_name +
                          " (" +
                          movie.lang_name +
                          ")";
                    return movie;
                  }
                }
              );
              this.showScheduleCard = true;
              // this.lists.movies = movieList;
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getAllActiveMovies :", error);
          });
      },
      getAllActiveScreens: function(cinema_id) {
        console.log("cinema_id :", cinema_id);
        this.ScreenList = [];
        let payload = {
          cinema_id: cinema_id,
        };

        scheduleService
          .GetScreens(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              // this.lists.screens = data.Records;
              this.ScreenList = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              this.ScreenListCopy = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              this.selectedMoviesInScreens = [];
              this.ScreenList.map((x) => {
                this.selectedMoviesInScreens.push({
                  ...x,
                  movies: [],
                });
              });
              console.log(this.ScreenList, this.selectedMoviesInScreens);
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveScreens :", error);
          });
      },
      getGoGoCategory: function() {
        this.CategoryList = [];
        MyCinemaService.getCategoryList()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              // this.lists.screens = data.Records;
              this.CategoryList = data.Records.filter((x) => {
                return x.category_id == "1";
              });
              console.log(this.CategoryList);
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveScreens :", error);
          });
      },
      getSeatTypesListByScreenId: function(screen_id) {
        scheduleService
          .GetSeatTypesByScreenId({ screen_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getSeatTypesListByScreenId :", error);
          });
      },
      onOpenAddPriceModal: function(
        screen,
        screenMovie,
        screenIndex,
        screenMovieIndex
      ) {
        this.movieSelected = screenMovie;
        this.selectedScreenSeatTypes = screen.screen_seat_types;
        this.selectedMovieIndex = screenMovieIndex;
        this.selectedScreenIndex = screenIndex;

        this.$refs.ratecardmodal.show();
      },
      onDeleteMovie: function(
        screen,
        screenMovie,
        screenIndex,
        screenMovieIndex
      ) {
        this.selectedMoviesInScreens[screenIndex].movies.splice(
          screenMovieIndex,
          1
        );
      },
      onChangeRateCardScreenMulti: function(ratecard, screenIndex) {
        this.MultiScheduleArray[screenIndex]["privateRateCard"][
          "rate_card_name"
        ] = ratecard.rc_g_name;
        this.MultiScheduleArray[screenIndex]["privateRateCard"][
          "rate_card_id"
        ] = ratecard.rc_id;
        this.MultiScheduleArray[screenIndex]["privateRateCard"][
          "rate_card_group_id"
        ] = ratecard.rc_g_id;

        this.$forceUpdate();
      },
      onChangeRateCardMulti: function(
        ratecard,
        seat,
        screenIndex,
        movieIndex,
        showTimeIndex,
        SeatTypeIndex
      ) {
        console.log("ratecard :", ratecard);
        this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
          "showTimeArray"
        ][showTimeIndex]["scheduling_price"][SeatTypeIndex]["rate_card_name"] =
          ratecard.rc_g_name;
        this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
          "showTimeArray"
        ][showTimeIndex]["scheduling_price"][SeatTypeIndex][
          "rate_card_group_id"
        ] = ratecard.rc_g_id;
        this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
          "showTimeArray"
        ][showTimeIndex]["scheduling_price"][SeatTypeIndex]["rate_card_id"] =
          ratecard.rc_id;

        this.$forceUpdate();
      },
      onChangeRateCard: function(ratecard, seat, SeatTypeIndex) {
        // console.log("event, seat, SeatTypeIndex :", event, seat, SeatTypeIndex);
        // this.selectedRateCardObject.rate_card_id = event.target.value;
        console.log("ratecard :", ratecard);
        this.selectedRateCardObject.rate_card_id = ratecard.rc_id;
        this.selectedRateCardObject.rate_card_group_id = ratecard.rc_g_id;
        this.selectedRateCardObject.rate_card_name = ratecard.rate_card_name;
        this.selectedRateCardObject.screen_seat_type_id = seat.sst_id;

        this.selectedRateCardObject.SeatTypeIndex = SeatTypeIndex;
        this.movieSelected.scheduleShowPrice.map((x) => {
          x.searchRateCard = "";
        });
        this.RatecardsList = this.RatecardsListCopy;
        console.log(
          "this.selectedRateCardObject :>> ",
          this.selectedRateCardObject
        );

        // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        //   this.selectedMovieIndex
        // ].scheduleShowPrice[SeatTypeIndex]["rate_card_id"] = event.target.value;

        // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        //   this.selectedMovieIndex
        // ].scheduleShowPrice[SeatTypeIndex]["rate_card_name"] =
        //   ratecard.rate_card_name;

        // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        //   this.selectedMovieIndex
        // ].scheduleShowPrice[SeatTypeIndex].rate_card_id = event.target.value;
        // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        //   this.selectedMovieIndex
        // ].scheduleShowPrice[SeatTypeIndex].screen_seat_type_id = seat.sst_id;

        // let z =
        //   this.selectedScreenIndex.toString() +
        //   this.selectedMovieIndex.toString();
        // this.rateCard[z].screen_seat_type_id = seat.sst_id;
        // this.rateCard[z].rate_card_id = event.target.value;
        // this.rateCard[z] = {
        //   test: "test"
        // };
        // console.log("this.rateCard[z] :", this.rateCard[z]);
        let obj = this.movieSelected.scheduleShowPrice[SeatTypeIndex];

        let _Obj = {
          ...obj,
          rate_card_id: ratecard.rc_id,
          rate_card_group_id: rc_g_id,
          searchRateCard: "",
          rate_card_name: ratecard.rc_g_name,
          screen_seat_type_id: seat.sst_id,
        };
        Vue.set(this.movieSelected.scheduleShowPrice, SeatTypeIndex, _Obj);
        this.$forceUpdate();
      },
      onClickupdateRateCard: function() {
        this.$refs.ratecardmodal.hide();
      },

      onSelectCinema: function(event, cinema) {
        this.selected.cinemaObject = cinema;
        this.selected.cinema = cinema.cine_name;
        this.scheduleObject.cinema_id = cinema.cine_id;
        this.getAllActiveScreens(cinema.cine_id);
        this.getCinemaSetting(cinema.cine_id);
        this.getRatecardsList(cinema.cine_id);
        this.clearMultiSchedule();
        this.submitted = false;
      },

      onSelectScreen: function(event, screen, screenIndex, screenMainIndex) {
        let findIndexScreen = this.MultiScheduleArray.findIndex((x) => {
          return x.screen_id == screen.screen_id;
        });
        if (findIndexScreen < 0 && screen.totalSeatLayout > 0) {
          this.MultiScheduleArray[screenMainIndex]["screen_name"] =
            screen.screen_name;
          this.MultiScheduleArray[screenMainIndex]["screen_id"] =
            screen.screen_id;
          this.MultiScheduleArray[screenMainIndex]["selectedScreen"] = screen;
          this.MultiScheduleArray[screenMainIndex]["minSeats"] = "";
          if (screen.screen_seat_types.length > 0) {
            let schedulingArray = [];
            screen.screen_seat_types.map((y) => {
              let obj = {
                screen_seat_type_id: y.sst_id,
                sst_seat_type: y.sst_seat_type,
                rate_card_id: "",
                searchRateCard: "",
                rate_card_private_id: 0,
                rate_card_name: "Select Rate Card Group",
              };
              schedulingArray.push(obj);
            });

            this.MultiScheduleArray[screenMainIndex]["moviesArray"].map((x) => {
              x.showTimeArray.map((z) => {
                z["scheduling_price"] = schedulingArray;
              });
            });
          } else {
            this.MultiScheduleArray[screenMainIndex]["moviesArray"].map((x) => {
              x.showTimeArray.map((z) => {
                z["scheduling_price"] = [];
              });
            });
          }
        } else if (screen.totalSeatLayout == 0) {
          this.$toasted.show(screen.screen_name + " has no seat layout");
        } else {
          this.$toasted.show(screen.screen_name + " Screen Already Exist");
        }
        console.log(this.MultiScheduleArray);

        // this.selectedMoviesInScreens[this.selectedScreenIndex]
        // this.selectedScreen = screen;
        // this.selected.screen_name = screen.screen_name;
        // this.selectedScreenIndex = screenIndex;

        // //newly added
        // this.selectedScreenSeatTypes = this.selectedScreen.screen_seat_types;
        // let seat_type_length = this.selectedMoviesInScreens[
        //   this.selectedScreenIndex
        // ].screen_seat_types
        //   ? this.selectedMoviesInScreens[this.selectedScreenIndex]
        //       .screen_seat_types.length
        //   : 0;
        // if (seat_type_length > 0) {
        //   let scheduleShowPriceObj = {
        //     rate_card_id: null,
        //     searchRateCard: "",
        //     rate_card_name: "Select Rate Card Group",
        //     schedule_show_id: null,
        //     screen_seat_type_id: null,
        //     p_start_date_time: null,
        //     p_end_date_time: null,
        //     p_is_active: "Y",
        //   };
        //   let scheduleShowPriceArray = [];
        //   for (var i = 0; i < seat_type_length; i++) {
        //     scheduleShowPriceArray.push(scheduleShowPriceObj);
        //   }
        //   Object.assign(this.movieSelected, {
        //     scheduleShowPrice: scheduleShowPriceArray,
        //   });
        //   this.$forceUpdate();
        // } else {
        //   this.$toasted.show("Screen Seat Type not found");
        // }
      },
      clearMultiSchedule() {
        this.MultiScheduleArray = [
          {
            screen_id: "",
            minSeats: "",
            screen_name: "Select Screen",
            selectShowType: [],
            selectedScreen: "",
            privateRateCard: {
              rate_card_id: "",
              rate_card_group_id: "",
              rate_card_name: "Select Rate Card Group",
              searchRateCard: "",
            },
            moviesArray: [
              {
                movie_details_id: "",
                selectedMovie: [],
                interval_time_in_mins: "",
                cleaning_time_in_mins: "",
                ads_time_in_mins: "",
                showTimeArray: [
                  {
                    start_time: "",
                    scheduling_price: [],
                    startTime2: "",
                    end_time: "",
                    endTime2: "",
                    interval_time_min: "",
                  },
                ],
                lengthMinutes: "",
              },
            ],
          },
        ];
      },

      onSelectMovie: function(movie, movieIndex, screenIndex) {
        // this.MultiScheduleArray[screenIndex]["moviesArray"][
        //   movieIndex
        // ].selectedMovie = movie;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].movie_details_id = movie.md_id;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].cleaning_time_in_mins = movie.cleaning_time_in_mins;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].ads_time_in_mins = movie.ads_time_in_mins;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].interval_time_in_mins = movie.interval_time_in_mins;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].lengthMinutes = movie.lengthMinutes;
        // let movieIndex = this.MoviesList.findIndex((x) => {
        //   return movie.md_id == x.md_id;
        // });

        // this.selectedMovie == movie;
        // this.selectedMovieIndex = movieIndex + Math.floor(Math.random() * 10);
        // this.movieSelected = {
        //   ...this.movieSelected,
        //   ...movie,
        // };
        // this.selectedScreenSeatTypes = this.selectedScreen.screen_seat_types;

        // let seat_type_length = this.selectedMoviesInScreens[
        //   this.selectedScreenIndex
        // ].screen_seat_types.length;

        // let scheduleShowPriceObj = {
        //   rate_card_id: null,
        //   searchRateCard: "",
        //   rate_card_name: "Select Rate Card Group",
        //   schedule_show_id: null,
        //   screen_seat_type_id: null,
        //   p_start_date_time: null,
        //   p_end_date_time: null,
        //   p_is_active: "Y",
        // };

        // let scheduleShowPriceArray = [];

        // for (var i = 0; i < seat_type_length; i++) {
        //   scheduleShowPriceArray.push(scheduleShowPriceObj);
        // }
        // if (String(this.selectedScreenIndex).length > 0) {
        //   Object.assign(this.movieSelected, {
        //     scheduleShowPrice: scheduleShowPriceArray,
        //   });
        // }
        this.$forceUpdate();
      },
      selectCinema: function(cinema) {
        this.lists.cinemas.selectedCinema = cinema;
      },

      doSomethingInParentComponentFunction: function() {},
      changeCinema: function(params) {
        this.initialSelectedScreen = params;
      },
      startDrag() {},
      endDrag: function(data) {},

      overLapIssue: function() {},
      dragEnter: function(screen, hour, minute) {
        this.dropLocation.screen = screen;
        this.dropLocation.hour = hour;
        this.dropLocation.minute = minute;
        // this.dropLocation.minute = minute;
      },
      openEditPopUp: function() {
        alert("popup");
      },
      handleDrop: function(data, event) {
        console.log("data :", data);

        // console.log("data, event :", data, event);
        //check if overlap with something else
        console.log("drop", this.dropLocation);
        let draggedMovie = data.movie;
        // console.log("this.draggedObject :", this.draggedObject);
        let doNotClone = 0;
        // let draggedMovie = this.selectedMoviesInScreens[this.draggedObject.screen]
        // .movies[this.draggedObject.movie];

        if (data.type == "presentMovie") {
          draggedMovie = this.selectedMoviesInScreens[this.draggedObject.screen]
            .movies[this.draggedObject.movie];

          this.draggedObject.newStart =
            (this.dropLocation.hour - 1) * 180 +
            (this.dropLocation.minute - 1) * 30;
          this.selectedMoviesInScreens[this.draggedObject.screen].movies[
            this.draggedObject.movie
          ].zIndex = 0;

          console.log("oldMovie :", draggedMovie);
          this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
            (otherMovie, index) => {
              //compare with start and start + length

              // draggedMoviestart > oldMovie start+length || draggedMoviestart +length < oldMovie start
              console.log("index, value :", index, otherMovie);
              console.log(
                "draggedMovie.start1 :",
                draggedMovie.start,
                draggedMovie.length,
                otherMovie.start,
                otherMovie.length,
                draggedMovie.start + draggedMovie.length,
                otherMovie.start + otherMovie.length
              );

              // if (
              //   this.draggedObject.newStart > otherMovie.start &&
              //   !(
              //     otherMovie.start + otherMovie.length <
              //     this.draggedObject.newStart
              //   )
              // ) {
              //   doNotClone = 1;
              //   alert("overlap1");
              // }
              if (
                this.draggedObject.newStart < otherMovie.start &&
                !(
                  this.draggedObject.newStart + draggedMovie.length <
                  otherMovie.start
                )
              ) {
                doNotClone = 1;
                alert("overlap old movie");
                if (
                  this.dropLocation.screen == this.draggedObject.screen &&
                  this.draggedObject.movie == index
                ) {
                  doNotClone = 0;
                }
              }

              // if (
              //   draggedMovie.start >
              //     parseInt(otherMovie.start) + parseInt(otherMovie.length) ||
              //   parseInt(draggedMovie.start) + parseInt(draggedMovie.length) <
              //     otherMovie.start
              // ) {
              //   doNotClone = 1;
              //   alert("overlap");
              // }
            }
          );
        }

        if (data.type == "newMovie") {
          console.log(
            "dd",
            this.selectedMoviesInScreens[this.dropLocation.screen].movies
          );
          this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
            (otherMovie, index) => {
              let scheduleShowPriceObj = {
                rate_card_id: null,
                rate_card_group_id: "",
                rate_card_name: "Select Rate Card Group",
                schedule_show_id: null,
                screen_seat_type_id: null,
                p_start_date_time: null,
                p_end_date_time: null,
                p_is_active: "Y",
              };
              otherMovie[0] = { scheduleShowPrice: scheduleShowPriceObj };
              let startCheck =
                (this.dropLocation.hour - 1) * 180 +
                (this.dropLocation.minute - 1) * 30;
              if (
                startCheck < otherMovie.start &&
                !(startCheck + draggedMovie.length < otherMovie.start)
              ) {
                doNotClone = 1;
                alert("overlap new movie");
              }
              // if (otherMovie.movie_details_id == data.movie.md_id) {
              //   let scheduleShowPriceObj = {
              //     rate_card_id: 1,
              //     schedule_show_id: "1",
              //     screen_seat_type_id: "18",
              //     p_start_date_time: 1,
              //     p_end_date_time: 1,
              //     p_is_active: "Y"
              //   };
              //   otherMovie.push({ scheduleShowPrice: scheduleShowPriceObj });
              // }
            }
          );
        }

        //create new movie
        if (doNotClone == 0) {
          this.selectedMoviesInScreens[
            this.dropLocation.screen
          ].movies = this.selectedMoviesInScreens[
            this.dropLocation.screen
          ].movies.filter((movie, index) => {
            console.log("lastCheck", movie);
            // if (movie.zIndex == 99) return movie;
            return movie.zIndex == 99;
          });
          // let dropScreen;
          // if(data.type == "presentMovie"){
          //   dropScreen = this.draggedObject.screen;
          // }else if (data.type == "newMovie"){
          //   dropScreen = this.dropLocation.screen;
          // }
          // if(this.selectedMoviesInScreens[this.dropLocation.screen].movies.filter((movie,movieIndex)=>{

          // }))

          this.selectedMoviesInScreens[this.dropLocation.screen].movies.push({
            length: draggedMovie.length,
            lengthMinutes: draggedMovie.lengthMinutes,
            movie_details_id: draggedMovie.md_id,
            md_id: draggedMovie.md_id,
            start:
              (this.dropLocation.hour - 1) * 180 +
              (this.dropLocation.minute - 1) * 30,
            zIndex: 99,
            mf_name: draggedMovie.mf_name,
            md_thumbnail_url: draggedMovie.md_thumbnail_url,
            lang_name: draggedMovie.lang_name,
            movie_title: draggedMovie.movie_title,
          });

          let seat_type_length = this.selectedMoviesInScreens[
            this.dropLocation.screen
          ].screen_seat_types.length;

          this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
            (x, movieIndex) => {
              let scheduleShowPriceObj = {
                rate_card_id: null,
                rate_card_group_id: "",
                rate_card_name: "Select Rate Card Group",
                schedule_show_id: null,
                screen_seat_type_id: null,
                p_start_date_time: null,
                p_end_date_time: null,
                p_is_active: "Y",
              };
              let scheduleShowPriceArray = [];
              console.log(
                'x.hasOwnProperty("scheduleShowPrice") :',
                x.hasOwnProperty("scheduleShowPrice")
              );
              console.log("x.scheduleShowPrice :", x.scheduleShowPrice);
              if (
                x.hasOwnProperty("scheduleShowPrice") &&
                x.scheduleShowPrice.length > 0
              ) {
                console.log("x.scheduleShowPrice :", x.scheduleShowPrice);
                scheduleShowPriceArray = x.scheduleShowPrice;
              } else {
                console.log("seat_type_length :", seat_type_length);
                // let z =
                //   this.dropLocation.screen.toString() + movieIndex.toString();
                // this.rateCard[z] = [];
                for (var i = 0; i < seat_type_length; i++) {
                  scheduleShowPriceArray.push(scheduleShowPriceObj);

                  //   this.rateCard[z].push(scheduleShowPriceObj);
                }
              }
              Object.assign(x, { scheduleShowPrice: scheduleShowPriceArray });
              //  x = { ...x,{scheduleShowPrice: scheduleShowPriceObj} };
            }
          );
        }
        if (doNotClone == 1 && data.type != "newMovie") {
          this.selectedMoviesInScreens[this.draggedObject.screen].movies.push({
            length: draggedMovie.length,
            lengthMinutes: draggedMovie.lengthMinutes,
            movie_details_id: draggedMovie.md_id,
            md_id: draggedMovie.md_id,
            start: draggedMovie.start,
            zIndex: 99,
            md_thumbnail_url: draggedMovie.md_thumbnail_url,
            mf_name: draggedMovie.mf_name,
            lang_name: draggedMovie.lang_name,
            movie_title: draggedMovie.movie_title,
          });
          let seat_type_length = this.selectedMoviesInScreens[
            this.dropLocation.screen
          ].screen_seat_types.length;
          this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
            (x, movieIndex) => {
              let scheduleShowPriceObj = {
                rate_card_id: null,
                rate_card_group_id: "",
                rate_card_name: "Select Rate Card Group",
                schedule_show_id: null,
                screen_seat_type_id: null,
                p_start_date_time: null,
                p_end_date_time: null,
                p_is_active: "Y",
              };
              let scheduleShowPriceArray = [];
              if (
                x.hasOwnProperty("scheduleShowPrice") &&
                x.scheduleShowPrice.length > 0
              ) {
                scheduleShowPriceArray = x.scheduleShowPrice;
              } else {
                let z =
                  this.dropLocation.screen.toString() + movieIndex.toString();
                this.rateCard[z] = [];
                for (var i = 0; i < seat_type_length; i++) {
                  scheduleShowPriceArray.push(scheduleShowPriceObj);

                  this.rateCard[z].push(scheduleShowPriceObj);
                }
              }
              Object.assign(x, { scheduleShowPrice: scheduleShowPriceArray });
              //  x = { ...x,{scheduleShowPrice: scheduleShowPriceObj} };
            }
          );
        }

        // alert(`You dropped with data: ${JSON.stringify(data)}`);
      },
      getTotalMovieTime: function(screenIndex, movieIndex) {
        let movieObj = this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ];

        let movierunTime = movieObj.selectedMovie.mrrdr_runtime || 0;
        let interval = movieObj.interval_time_in_mins || 0;
        let cleaningTime = movieObj.cleaning_time_in_mins || 0;
        let advertisementTime = movieObj.ads_time_in_mins || 0;

        return movierunTime + interval + cleaningTime + advertisementTime;
      },
      validateMinSeats: function($event, screenObj) {
        let selectedMinSeats = $event.target.value;
        if (parseInt(selectedMinSeats) && parseInt(selectedMinSeats) > 0) {
          let totalSeats = screenObj["selectedScreen"].screen_no_of_seats;
          if (parseInt(selectedMinSeats) > totalSeats) {
            this.$toasted.show(
              "Minimum seats cannot be greater than total seats"
            );
            screenObj.minSeats = "";
          }
        } else {
          this.$toasted.show("Enter a valid number");
          screenObj.minSeats = "";
        }
      },
      closeModalSection: function() {},
      moment: moment,
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/MyCinemaComponents/MultiScheduling/addSchedulingV2.vue